<template>
  <div class="product">
    <div class="column small-cell">{{ theUser.name }}</div>
    <div class="column small-cell">{{ theUser.date }}</div>
    <div class="column small-cell">{{ theUser.mobile }}</div>
    <div class="column small-cell">{{ theUser.order_number }}</div>
    <div class="column small-cell">{{ theUser.district }}</div>
    <div class="column small-cell">
      <textarea
        @focus="show_submit(theUser.id)"
        @blur="hide_submit(theUser.id)"
        v-model="theUser.comment"
        class="description"
        rows="3"
        name=""
      ></textarea>
      <div v-if="theUser.id == show_my_submit" class="text-center">
        <button @click="submit_description(theUser)" class="submit-description">
          ثبت
        </button>
      </div>
    </div>
    <div class="column small-cell">
      <button class="purple-btn" @click="goToPanel">ورود به حساب</button>
    </div>
  </div>
</template>
<script>
import { computed, onMounted, ref, inject } from "@vue/composition-api";
import Service from "../../../../utils/admin-service";

export default {
  props: ["theUser"],
  setup(props, context) {
    const show_my_submit = ref();
    const theService = computed(() => {
      return Service(false);
    });
    const show_submit = function (me) {
      show_my_submit.value = me;
    };
    const hide_submit = function (me) {
      setTimeout(() => {
        show_my_submit.value = 0;
      }, 300);
    };
    onMounted(() => {});

    const submit_description = function (theUser) {
      let formData = new FormData();
      if (theUser.comment == "") {
        theService.value.remove("admin/desc/user/" + theUser.id, (s, d) => {});
      } else {
        formData.append("comment", theUser.comment);
        theService.value.transmit(
          "admin/desc/user/" + theUser.id,
          formData,
          (s, d) => {}
        );
      }
    };

    const goToPanel = function () {
      this.$emit("goToPanel", this.theUser.id);
    };
    return {
      goToPanel,
      submit_description,
      show_submit,
      hide_submit,
      show_my_submit,
    };
  },
};
</script>
<style lang="scss" scoped>
td {
  border: 1px solid rgba(127, 127, 127, 0.2);
  white-space: nowrap;
  padding: 0.5rem;
}

tr {
  width: 100%;
}

.order-locker img {
  width: 50%;
}

.small-cell {
  width: 5%;
}

.mid-cell {
  width: 12vw;
}

.mid-cell p {
  white-space: pre-wrap;
  overflow: hidden;
}

.large-cell {
  width: 23%;
}
.column {
  display: inline-block;
  text-align: center;
}
.small-cell {
  display: inline-block;
  width: calc(100% / 7);
  padding: 1rem;
  vertical-align: middle;
}
.product {
  border-bottom: solid 1px #f1f0f0;
}
.description {
  font-size: 12px;
  outline: none;
  /* border: solid 1px rgb(224, 224, 224); */
  border-radius: 5px;
  box-shadow: 0 0 2px #dfdede;
  width: 100%;
  margin-bottom: -8px;
}
.submit-description {
  padding: 5px;
  border-radius: 5px;
  color: white;
  outline: none;
  width: 100%;
  margin-top: 15px;
  background: #0a77cd;

  &:hover {
    background: #2196f3;
  }
}
</style>